import type { ReactNode } from 'react'

import type { SearchModalFilterChip } from '../interfaces/modalFilterChip.interface'
import type { SearchModalItem } from '../interfaces/modalItem.interface'
import type { SearchModalSection } from '../interfaces/modalSection.interface'

import { SearchChips } from './SearchChips'
import { SearchSection } from './SearchSection'

import styles from '../SearchModal.module.scss'

type SearchResultsProps = {
  activeFilterChipId?: string | null
  emptyState?: ReactNode
  filterChips?: readonly SearchModalFilterChip[]
  isLoading: boolean
  query: string
  sections: SearchModalSection[]
  selectedIndex: number
  showEmptyPlaceholder: boolean
  onFilterChipChange?: (id: string) => void
  onItemHover: (index: number) => void
  onItemSelect: (item: SearchModalItem) => void
}

export function SearchResults({
  activeFilterChipId,
  emptyState,
  filterChips,
  isLoading,
  query,
  sections,
  selectedIndex,
  showEmptyPlaceholder,
  onFilterChipChange,
  onItemHover,
  onItemSelect,
}: SearchResultsProps) {
  let nextSectionStartIndex = 0

  return (
    <div className={styles.scrollArea}>
      <SearchChips
        activeFilterChipId={activeFilterChipId}
        filterChips={filterChips}
        onFilterChipChange={onFilterChipChange}
      />

      {isLoading ? <div className={styles.loadingPad}>Searching...</div> : null}

      {!isLoading
        ? sections.map((section) => {
            const startIndex = nextSectionStartIndex
            nextSectionStartIndex += section.items.length

            return (
              <SearchSection
                key={section.id}
                query={query}
                section={section}
                selectedIndex={selectedIndex}
                startIndex={startIndex}
                onItemHover={onItemHover}
                onItemSelect={onItemSelect}
              />
            )
          })
        : null}

      {showEmptyPlaceholder ? <div className={styles.empty}>{emptyState}</div> : null}

      {sections.every((section) => section.items.length === 0) && !isLoading && emptyState === undefined ? (
        <div className={styles.empty}>Nothing matched yet.</div>
      ) : null}
    </div>
  )
}
